import React from "react";

// 8 agreed items, 12.5% each; computed from saved shop data only.
export const completenessItems = (shop, hasLoc) => [
  { key: "name", label: "Shop name", done: !!shop.name?.trim(), target: "shop-field-name" },
  { key: "logo", label: "Logo", done: !!shop.logo?.trim(), target: "shop-logo-section" },
  { key: "image", label: "Shop photo", done: !!shop.image?.trim(), target: "shop-image-section" },
  { key: "tagline", label: "Tagline", done: !!shop.tagline?.trim(), target: "shop-field-tagline" },
  { key: "description", label: "Description", done: !!shop.description?.trim(), target: "shop-field-description" },
  { key: "phone", label: "Phone number", done: String(shop.phone || "").replace(/\D/g, "").length >= 10, target: "shop-field-phone" },
  { key: "address", label: "Address + PIN", done: !!shop.address?.trim() && /^\d{6}$/.test(shop.pincode || ""), target: !shop.address?.trim() ? "shop-field-address" : "shop-field-pincode" },
  { key: "location", label: "Map location", done: hasLoc, target: "detect-shop-location" },
];

export function ProfileCompleteness({ shop, hasLoc, onOpen, skip = [] }) {
  const items = completenessItems(shop, hasLoc);
  const done = items.filter((i) => i.done).length;
  if (done === items.length) return null;
  const pct = Math.round((done / items.length) * 100);
  const left = items.filter((i) => !i.done && !skip.includes(i.key));
  return (
    <div className="rounded-xl border border-slate-200 bg-white px-3 py-3" data-testid="profile-completeness">
      <div className="flex items-center justify-between gap-2 text-sm">
        <span className="font-bold text-slate-900">Shop profile <span data-testid="profile-completeness-pct">{pct}%</span> complete</span>
        <span className="text-xs text-slate-500">{done}/{items.length}</span>
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-slate-200 overflow-hidden" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="h-full bg-emerald-600 rounded-full transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      {left.length > 0 && <div className="mt-2.5 flex flex-wrap gap-1.5">
        <span className="text-xs text-slate-500 self-center">Baaki:</span>
        {left.map((i) => (
          <button key={i.key} onClick={() => onOpen(i.target)} className="rounded-full border border-amber-300 bg-amber-50 hover:bg-amber-100 text-amber-900 px-3 py-1 text-xs font-semibold min-h-[32px]" data-testid={`completeness-chip-${i.key}`}>
            + {i.label}
          </button>
        ))}
      </div>}
    </div>
  );
}
